import { useMutation, useQueryClient } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

import { TRANSFER_LIST_QUERY_KEY } from './useTransferListQuery';
import { TRANSFER_STATS_QUERY_KEY } from './useTransferStatsQuery';

const MUT_INITIATE_CANCEL_TRANSFER = 'initiate-cancel-transfer-mutation';

interface IInitiateCancelTransferMutationParam {
  onError?: (err: IApiError) => void;
  onSuccess?: () => void;
}

/**
 * Custom hook for initiating cancel transfer.
 */
export const useInitiateCancelTransferMutation = ({
  onError,
  onSuccess,
}: IInitiateCancelTransferMutationParam) => {
  const queryClient = useQueryClient();
  const { isPending, isError, error, data, mutate, isSuccess, reset } =
    useMutation({
      mutationKey: [MUT_INITIATE_CANCEL_TRANSFER],
      networkMode: 'always',
      mutationFn: INV_MGMT_SERVICE_API.initiateCancelTransfer,
      onError,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [TRANSFER_LIST_QUERY_KEY] });
        queryClient.invalidateQueries({ queryKey: [TRANSFER_STATS_QUERY_KEY] });

        onSuccess?.();
      },
    });

  return {
    isInitiateCancelTransferError: isError,
    isInitiateCancelTransferOngoing: isPending,
    isInitiateCancelTransferSuccess: isSuccess,
    initiateCancelTransferError: error,
    initiateCancelTransfer: mutate,
    resetInitiateCancelTransfer: reset,
    data,
  };
};
